module.exports = __webpack_public_path__ + "static/media/accountingtabimg.6737d311.png";